import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';
import Button from '@wix/da-shared-react/pkg/Button';
import MiniProfileIdentity from '../_partials/MiniProfileIdentity';
import { PapiUser } from '@wix/da-types-papi';
import reduxConnectContainer from './RecentVisitors.container';

import s from './RecentVisitors.scss';

const enhance = compose(reduxConnectContainer, withTranslation());

export interface Props {
  isOwner: boolean;
  moduleId: number;
  visitors: PapiUser[];
  canLoadMore?: boolean;
  hasMore?: boolean;
  isFetching?: boolean;
  fetchMore?: () => void;
}

export class RecentVisitors extends React.Component<Props & WithTranslation> {
  render() {
    const { t, visitors, canLoadMore, fetchMore, isFetching } = this.props;
    const isEmpty = !visitors || visitors.length === 0;
    return isEmpty ? null : (
      <>
        {this.renderGrid()}
        {canLoadMore && (
          <Button
            view="b8"
            onClick={fetchMore}
            disabled={isFetching}
            className={s['load-more-button']}
          >
            {t('common.loadMore')}
          </Button>
        )}
      </>
    );
  }

  renderGrid() {
    const { visitors } = this.props;
    return (
      <ElementQueries widthBreakpoints={[640, 800]} className={s['grid']}>
        {visitors.map(this.renderGridElement)}
      </ElementQueries>
    );
  }

  renderGridElement = (visitor: PapiUser) => {
    const { username } = visitor;
    return (
      <MiniProfileIdentity
        key={username}
        className={s['visitor']}
        user={visitor}
      />
    );
  };
}

export default enhance(RecentVisitors);
